import { Image, getGamePassesImg } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";

import { PassAction, PassActionTypes } from "./Pass";
export const passGetImages = (entitlementId: string) => {
  return (dispatch: Dispatch<PassAction>) => {
    dispatch({ type: PassActionTypes.PASS_GET_IMAGES_REQUEST });
    return new Promise<Image[]>((resolve, reject) => {
      getGamePassesImg(entitlementId).subscribe({
        next: (res) => {
          dispatch({
            type: PassActionTypes.PASS_GET_IMAGES_SUCCESS,
            passId: entitlementId,
            images: res,
          });
          resolve(res);
        },
        error: (error) => {
          dispatch({ type: PassActionTypes.PASS_GET_IMAGES_ERROR, error });
          reject(error);
        },
      });
    });
  };
};
